import {
    ParticipantMatchListActions,
    ParticipantMatchListSetFilterDataAction,
    ParticipantMatchListSetLoadingData,
    ParticipantMatchListStoreModel,
} from './participant-match-list.constants';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { filterItemsFromRecords } from '../../utils/filter-items-from-records';
import applyUpdatesForMatchList from '../../utils/apply-updates-for-match-list';
import { getParticipantMatchListSliceName } from './participant-match-list.utils';
import { AggregatorOneOfTypeModel } from '@om-fe/models';
import { UpdateAction } from '@om-fe/api';
import { isBrowser } from '@om-fe/utils';

const initialState: ParticipantMatchListStoreModel = {
    fetchedFromBrowser: isBrowser(),
    ready: false,
    limit: 0,
    totalRecords: 0,
    isLoadingMoreData: false,
    isLoadingData: true,
    discipline: undefined,
    filteredEventInfos: {},
    filteredMainMarketsList: [],
    filteredMainMarkets: {},
    filteredMarketGroupsOverviewList: [],
    filteredMarketGroupsOverview: {},
    filteredEventStatistics: [],
    filteredMarketAndOutcomeRelation: {},
    filteredOutcomes: {},
    filteredBettingOffers: {},
    filteredMatchesWithEvents: {},
    filteredMatchesIds: [],
    marketsWithOutcomesAndBettingOffers: {},
    filteredStreamingProviderEventRelation: {},
};

export const participantMatchListReducerCreator = (instanceId: string) => (
    state: ParticipantMatchListStoreModel = initialState,
    action: AppAction,
): ParticipantMatchListStoreModel => {
    const slice: string = getParticipantMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case ParticipantMatchListActions.SetLoadingData: {
            const { payload: { isLoadingMoreData } } = action as ParticipantMatchListSetLoadingData;

            return {
                ...state,
                isLoadingData: !isLoadingMoreData,
                isLoadingMoreData,
            };
        }
        case ParticipantMatchListActions.SetFilterData: {
            const { payload } = action as ParticipantMatchListSetFilterDataAction;

            return {
                ...state,
                participantId: payload.participantId,
                liveStatus: payload.liveStatus,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            const records: AggregatorOneOfTypeModel[] = payload.records;

            return {
                ...state,
                ...filterItemsFromRecords(records),
                fetchedFromBrowser: isBrowser(),
                ready: true,
                isLoadingData: false,
                isLoadingMoreData: false,
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
                isLoadingMoreData: false,
            };
        }
        default:
            return state;
    }
};
